var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    studio_packages: [],
    studio_dropdowns: [],
};
export var moduleBuilderSlice = createSlice({
    name: "moduleBuilder",
    initialState: initialState,
    reducers: {
        setStudioPackages: function (state, data) {
            state.studio_packages = data.payload;
        },
        setStudioDropdowns: function (state, data) {
            state.studio_dropdowns = data.payload;
        },
    },
});
export var setStudioPackages = (_a = moduleBuilderSlice.actions, _a.setStudioPackages), setStudioDropdowns = _a.setStudioDropdowns;
export default moduleBuilderSlice.reducer;
